import { useQuery } from '@tanstack/react-query'
import { tenMinutes } from '~constants/constants'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'

export interface GetPortInfoAutocompleteParams {
  terminalName?: string
  berthName?: string
  enabled?: boolean
}

export function useGetPortInfoAutocomplete(
  params: GetPortInfoAutocompleteParams,
) {
  const fetchRequest = useFetch<string[]>()
  const { enabled = true, terminalName, berthName } = params

  const queryParams = new URLSearchParams()
  if (terminalName) queryParams.set('terminalName', terminalName)
  if (berthName) queryParams.set('berthName', berthName)

  const url = `/portinfo/autocomplete?${queryParams.toString()}`

  return useQuery({
    queryKey: [url],
    queryFn: () => fetchRequest(`${apiBase()}${url}`),
    staleTime: tenMinutes,
    enabled,
  })
}
